module.exports = __webpack_public_path__ + "img/e-resize.png?092242aa07d410e80f5f3e75e083ac5a";